export const PlanningRouteShipmentsComponentName: string = 'planningRouteShipments';
